import styled, { css, DefaultTheme, StyledProps, ThemeProps } from 'styled-components';

const opacityTransition = 'opacity 0.3s ease-out';

export type IconSize =
  | 'x-small'
  | 'small'
  | 'medium'
  | 'large'
  | 'x-large'
  | 'xx-large'
  | 'xxx-large';
export type IconColor = string | ((props: ThemeProps<DefaultTheme>) => string);

export type IconStyleProps = {
  fillColor?: IconColor;
  flipX?: boolean;
  flipY?: boolean;
  size: IconSize;
};

export const getIconSize = ({ size, theme }: StyledProps<IconStyleProps>): string => {
  switch (size) {
    case 'xxx-large':
      return `${theme.layout.baseSpacingPx * 8}px`;
    case 'xx-large':
      return `${theme.layout.baseSpacingPx * 6}px`;
    case 'x-large':
      return `${theme.layout.baseSpacingPx * 5}px`;
    case 'large':
      return `${theme.layout.baseSpacingPx * 4}px`;
    case 'medium':
      return `${theme.layout.baseSpacingPx * 3}px`;
    case 'x-small':
      return `${theme.layout.baseSpacingPx * 1.5}px`;
    case 'small':
    default:
      return `${theme.layout.baseSpacingPx * 2}px`;
  }
};

export const IconWrapper = styled.span<IconStyleProps>`
  position: relative;
  display: inline-block;
  width: ${getIconSize};
  height: ${getIconSize};
  line-height: 1;

  ${({ flipX, flipY }) => {
    const x = flipX ? -1 : 1;
    const y = flipY ? -1 : 1;
    return (
      (x === -1 || y === -1) &&
      css`
        transform: scale(${x}, ${y});
      `
    );
  }};

  svg {
    width: 100%;
    height: 100%;
    fill: ${({ fillColor }) => fillColor ?? 'currentColor'};
    pointer-events: none;
  }
`;

type SVGWrapperProps = {
  active?: boolean;
};

export const SVGWrapper = styled.span<SVGWrapperProps>`
  position: absolute;
  display: block;
  transition: ${opacityTransition};
  opacity: ${(props) => (props.active ? 1 : 0)};
  width: inherit;
  height: inherit;
`;
